import { trimAndAddAsterisk } from '../../utility/QueryUtility';
import {
  commonDateParamMappings,
  filterParamMapping,
} from '../common/mappings';

export const claimTasksServiceMappings = [
  ...commonDateParamMappings,
  // The task search pages by cursor: `size` per page, and `searchAfter` with `pageRequested`
  // (NEXT or PREV) to move. It never reads `page`, so the console keeps that to itself.
  { path: 'size' },
  { path: 'searchAfter' },
  { path: 'pageRequested' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'dueDate':
            return `${orderBy},${order}`;
          default:
            return `${orderBy}.keyword,${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
  filterParamMapping,
];
